
import { Component, Vue } from 'vue-property-decorator'
import moment from 'moment'
import { getAuthEvents, getUserAuthHistory } from '@/api/authEvents'

@Component({ name: 'AuthEvents' })
export default class extends Vue {
  private activeTab = 'logout'
  private list: any[] = []
  private listLoading = false
  private total = 0
  private currentPage = 1
  private pageSize = 20
  private dateRange: string[] = []
  private searchText = ''
  private onlyFailed = false

  private detailDialogVisible = false
  private detailUserId = ''
  private detailEmail = ''
  private detailList: any[] = []
  private detailLoading = false
  private detailTotal = 0
  private detailPage = 1

  created() { this.fetchData() }

  private handleTabChange() {
    this.currentPage = 1
    this.list = []
    this.total = 0
    this.fetchData()
  }

  private handleFilter() {
    this.currentPage = 1
    this.fetchData()
  }

  private handleSizeChange(s: number) {
    this.pageSize = s
    this.currentPage = 1
    this.fetchData()
  }

  private handlePageChange(p: number) {
    this.currentPage = p
    this.fetchData()
  }

  private async fetchData() {
    this.listLoading = true
    try {
      const params: any = { tab: this.activeTab, page: this.currentPage, limit: this.pageSize }
      if (this.dateRange && this.dateRange.length === 2) {
        params.startDate = this.dateRange[0]
        params.endDate = this.dateRange[1]
      }
      if (this.searchText && this.searchText.trim()) params.search = this.searchText.trim()
      if (this.activeTab === 'login' && this.onlyFailed) params.status = 'failed'

      const response = await getAuthEvents(params)
      const resData = response.data?.data || {}
      const items = resData.items || []
      this.list = Array.isArray(items) ? items : []
      this.total = resData.pagination?.total || 0
    } catch {
      this.list = []
      this.total = 0
    } finally {
      this.listLoading = false
    }
  }

  private showUserDetail(row: any) {
    if (!row.userId) return
    this.detailUserId = row.userId
    this.detailEmail = row.email || 'Unknown'
    this.detailPage = 1
    this.detailDialogVisible = true
    this.fetchDetailData()
  }

  private handleDetailPageChange(p: number) {
    this.detailPage = p
    this.fetchDetailData()
  }

  private async fetchDetailData() {
    this.detailLoading = true
    try {
      const response = await getUserAuthHistory(this.detailUserId, { page: this.detailPage, limit: 20 })
      const raw = response.data
      // Handle multiple response formats
      const resData = raw?.data || raw || {}
      const items = resData.items || resData.rows || (Array.isArray(resData) ? resData : [])
      this.detailList = Array.isArray(items) ? items : []
      this.detailTotal = resData.pagination?.total || resData.count || items.length || 0
      console.log('[AuthEvents] Detail response:', { userId: this.detailUserId, rawKeys: Object.keys(raw || {}), dataKeys: Object.keys(resData || {}), itemCount: this.detailList.length, total: this.detailTotal })
    } catch (err) {
      console.error('[AuthEvents] Detail error:', err)
      this.detailList = []
      this.detailTotal = 0
    } finally {
      this.detailLoading = false
    }
  }

  private formatDate(d: string) { return d ? moment(d).format('DD.MM.YYYY HH:mm') : '-' }
  private truncateText(t: string, max: number) { return t && t.length > max ? t.slice(0, max) + '...' : t || '' }

  private getLoginTypeTagType(t: string) {
    return ({ email: '', phone: 'success', firebase: 'warning' } as any)[t] || 'info'
  }

  private getReasonLabel(r: string) {
    if (!r) return ''
    return ({
      redis_key_missing: 'Token Expired (Redis)',
      token_mismatch: 'Token Mismatch',
      token_expired: 'Token Expired',
      user_not_found: 'User Not Found',
      user_initiated: 'User Logout',
      wrong_code: 'Wrong Code',
      invalid_password: 'Invalid Password',
    } as any)[r] || r
  }

  private getEventTypeTagType(t: string) {
    return ({
      login_success: 'success',
      login_failed: 'danger',
      logout: '',
      token_expired: 'warning',
      auth_reject: 'danger',
    } as any)[t] || 'info'
  }

  private getEventTypeLabel(t: string) {
    return ({
      login_success: 'Login Success',
      login_failed: 'Login Failed',
      logout: 'Logout',
      token_expired: 'Token Expired',
      auth_reject: 'Auth Reject',
    } as any)[t] || t
  }
}
